import { render, staticRenderFns } from "./ProjectShowSubmitalCard.vue?vue&type=template&id=74f34aec&"
import script from "./ProjectShowSubmitalCard.vue?vue&type=script&lang=js&"
export * from "./ProjectShowSubmitalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports